// components/widgets/primitives/action-chip.js
// ═══════════════════════════════════════════════════════════
// ACTION CHIP — color-coded by sentiment, holds an action option
// with confidence + reasoning + meta fields.
// ═══════════════════════════════════════════════════════════
// Tone is auto-derived from confidence unless explicitly passed:
//   conf >= 0.70 → sage  (positive, do it)
//   conf 0.50-0.69 → steel (neutral, consider)
//   conf < 0.50  → amber (caution, weak signal)
//
// Variant overrides:
//   'planning' → teal (different category, not action)
//   'risk'     → terra (negative, avoid)
// ═══════════════════════════════════════════════════════════

import MetaField from './meta-field';

function deriveTone(conf, variant) {
  if (variant === 'planning') return 'teal';
  if (variant === 'risk') return 'terra';
  if (conf == null) return 'steel';
  if (conf >= 0.70) return 'sage';
  if (conf < 0.50) return 'amber';
  return 'steel';
}

export default function ActionChip({ option = {}, variant = 'action', className = '' }) {
  const conf = typeof option.confidence === 'number' ? option.confidence : null;
  const confPct = conf != null ? Math.round(conf * 100) : null;
  const tone = option.tone || deriveTone(conf, variant);

  return (
    <div className={`ws-prim-chip ws-prim-chip-${tone} ${className}`}>
      <div className="ws-prim-chip-head">
        <span className="ws-prim-chip-what">{option.what}</span>
        {confPct != null && (
          <span className="ws-prim-chip-conf">{confPct}%</span>
        )}
      </div>
      {option.why_now && (
        <div className="ws-prim-chip-why">{option.why_now}</div>
      )}
      {Array.isArray(option.assumptions) && option.assumptions.length > 0 && (
        <MetaField label="assumes">
          {option.assumptions.join(' · ')}
        </MetaField>
      )}
      {option.trade_off && (
        <MetaField label="trade-off">{option.trade_off}</MetaField>
      )}
      {variant === 'planning' && option.horizon && (
        <MetaField label="horizon">{option.horizon}</MetaField>
      )}
      {option.confidence_drivers && (
        <MetaField label="would change my mind">{option.confidence_drivers}</MetaField>
      )}
    </div>
  );
}
